// utils/renderMarkup.js
export function renderMarkup(text) {
  if (!text) return null

  // Split on <accent>...</accent> or <br/> while keeping the delimiters
  const tokens = text.split(/(<accent>.*?<\/accent>|<br\/>)/g)

  return tokens.map((token, i) => {
    if (token === '<br/>') return <br key={i} />

    const accentMatch = token.match(/^<accent>(.*?)<\/accent>$/)
    if (accentMatch) {
      return (
        <span key={i} className='accent'>
          {accentMatch[1]}
        </span>
      )
    }

    return token
  })
}
